// Maison Fermoir, 17/10/2026 (Mika) — Le titre de la fiche suit la finition ou la couleur choisie.
// `blocks/text.liquid` pose « - Doré » dans un <span data-mf-titre-variante="<id produit>"> ; le sélecteur de variante
// ne re-rend pas ce bloc, il publie seulement la page de la nouvelle variante dans l'événement `variant:updated`
// (qui remonte jusqu'au document). On y relit le <span> du MÊME produit et on recopie son texte. ⚠ L'événement ne porte
// pas d'id produit utilisable (le sélecteur n'a pas de `data-product-id`) : c'est l'id du <span> qui filtre, et une
// carte de suggestion, qui rend un autre produit, ne contient jamais le <span> de la fiche.
document.addEventListener('variant:updated', (e) => {
  const html = e.detail?.data?.html;
  if (!html) return;
  document.querySelectorAll('[data-mf-titre-variante]').forEach((el) => {
    const neuf = html.querySelector(`[data-mf-titre-variante="${el.dataset.mfTitreVariante}"]`);
    if (neuf) el.textContent = neuf.textContent;
  });
});
